import $ from 'jquery';

function setDateFormat(date) {
    const date_format = new Date(date);
    const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return `${month[date_format.getMonth()]} ${date_format.getDate()}, ${date_format.getFullYear()}`;
}

function paintReviewsFacebook(response) {
    let reviews = '';
    for (let i = 0; (i < response.data.length); i++) {
        let date = setDateFormat(response.data[i].created_time);
        if ('positive' === response.data[i].recommendation_type && true === response.data[i].has_review) {
            if (true === response.data[i].has_rating && 2 < response.data[i].rating) {
                reviews += `<div class="item-reviews"><p class="item-reviews__data item-reviews__data--text">${response.data[i].review_text}</p><p class="item-reviews__data item-reviews__data--date">${date}</p><p class="item-reviews__data item-reviews__data--rating">Rating: ${response.data[i].rating}</p></div>`
            } else {
                reviews += `<div class="item-reviews"><p class="item-reviews__data item-reviews__data--text">${response.data[i].review_text}</p><p class="item-reviews__data item-reviews__data--date">${date}</p></div>`
            }
        }
    }
    $('#sec_reviews').append(reviews);
}

function apiFacebook(url, callback) {
    $.ajax({
        url: url,
        success: callback
    });
}

$(document).ready(function () {
    const facebook_page = '';
    const access_token = '';
    apiFacebook(`https://graph.facebook.com/${facebook_page}/ratings/?fields=review_text,created_time,recommendation_type,has_rating,has_review,reviewer,rating&access_token=${access_token}`, paintReviewsFacebook);
});
